import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError } from "libs/api";

import { SUPPORT_TICKETS_QUERY_KEY } from "../../constants/enums";
import {
  GetActiveTicketsCountParams,
  GetActiveTicketsCountResponse,
  requestGetActiveTicketsCount,
} from "./getActiveTicketsCount.request";

const useGetActiveTicketsCount = (
  params: GetActiveTicketsCountParams = {},
  options?: { enabled?: boolean },
) => {
  return useQuery<GetActiveTicketsCountResponse, ApiServiceError<ApiError>>({
    queryKey: [SUPPORT_TICKETS_QUERY_KEY, "active-count", params],
    queryFn: async () => await requestGetActiveTicketsCount(params),
    onError: toastServerError,
    keepPreviousData: true,
    enabled: options?.enabled ?? true,
  });
};

export default useGetActiveTicketsCount;
